var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.warningZone ? _c("div", [_vm._v("warning")]) : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }